export const columns = [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'eventName', headerName: 'Event Name', width: 300 },
  { field: 'name', headerName: 'Rubric Name', width: 300 },
  { field: 'maxPoints', headerName: 'Max Points', width: 130 },
];
